import { useClientPortalAPI, useQueryParams } from "@certn/api";
import { components } from "@certn/api/generated-schemas/client-portal";
import { Container } from "@certn/cascadia-react";
import { useContext, useEffect } from "react";

import { PackageDetails } from "../../../components/package-details/PackageDetails";
import { OrderContext } from "../OrderContext";
import { OrderStepLayout } from "../components/OrderStepLayout";

export function PackageDetailsStep() {
  const { goToNextStep, order, setOrder, setIsLoading } =
    useContext(OrderContext);
  const { params } = useQueryParams();
  const packageID = params.package_id;
  const groupID = params.group_id;

  const { data, isLoading: isLoadingPackage } = useClientPortalAPI(
    packageID ? `/api/internal/client-portal/packages/${packageID}/` : null
  );
  const { data: packagePrice, isLoading } = useClientPortalAPI(
    packageID
      ? `/api/internal/client-portal/packages/${packageID}/customer-group/${groupID}/package-price/`
      : null
  );
  const checks = data?.checks || [];
  const tags = data?.tags as unknown as components["schemas"]["Tags"][];
  const price = packagePrice
    ? packagePrice
    : data?.price || { price: 0, currency: "CAD" };

  const packageData = {
    id: packageID as string,
    name: data?.name || "",
    price,
    checks:
      checks?.map((check) => ({
        id: check.type,
        name: check.name,
        check_arguments: check.check_arguments,
        selected_options: check.selected_options || [],
        add_on_options: check.add_on_options,
      })) || [],
    bundles: data?.bundles || [],
    tags: tags || [],
  };

  useEffect(() => {
    setIsLoading(isLoadingPackage || isLoading);
  }, [isLoading, isLoadingPackage, setIsLoading]);

  return (
    <OrderStepLayout
      onComplete={() => {
        setOrder({
          ...order,
          group: groupID as string,
          tags: packageData.tags,
          packageData,
        });
        goToNextStep();
      }}
    >
      <Container padding={["space-0", "space-2"]} layout="narrow">
        {data && (
          <PackageDetails
            name={data.name}
            description={data.description}
            price={price}
            tags={data.tags}
            checks={checks}
            adjudicationRubric={data.adjudication_rubric || undefined}
          />
        )}
      </Container>
    </OrderStepLayout>
  );
}
